
import i18n from '@/i18n'
import { DataTableColumn, ColumnSet } from '@/model/DataTableColumn.js'
import { lengthGroupSorterByLabel } from '@/components/account/account-scaling/length-groups/LengthGroups.js'
import { diameterGroupSorterByLabel } from '@/components/account/account-scaling/diameter-groups/DiameterGroups.js'

export function rateSheetLineHeaders (isCRUD = false) {
  const headers = [
    !isCRUD ? {
      id: 0,
      text: '',
      value: 'isLocked',
      align: 'left',
      sortable: true,
      width: 64,
      cellClass: 'is-locked'
    } : undefined,
    {
      id: 1,
      text: i18n.t('speciesGroup'),
      value: 'speciesGroup',
      sortable: true,
      cellClass: 'species-group'
    },
    {
      id: 2,
      text: i18n.t('lengthGroup'),
      value: 'lengthGroup',
      sortable: true,
      cellClass: 'length-group',
      sort: lengthGroupSorterByLabel
    },
    {
      id: 3,
      text: i18n.t('diameterGroup'),
      value: 'diameterGroup',
      sortable: true,
      cellClass: 'diameter-group',
      sort: diameterGroupSorterByLabel
    },
    {
      id: 4,
      text: i18n.t('grade'),
      value: 'grade',
      sortable: true,
      cellClass: 'grade'
    },
    {
      id: 5,
      text: i18n.t('endUseSort'),
      value: 'endUseSort',
      sortable: true,
      cellClass: 'end-use-sort'
    },
    {
      id: 6,
      text: i18n.t('rate'),
      value: 'rate',
      align: 'right',
      sortable: true,
      cellClass: 'rate'
    },
    isCRUD ? {
      id: 7,
      text: '',
      value: 'actions',
      align: 'right',
      sortable: false,
      width: 72,
      cellClass: 'actions'
    } : undefined
  ].filter(i => i)

  return new ColumnSet({
    columns: headers.map(header => new DataTableColumn(header)),
    name: 'rateSheetLineHeader'
  })
}
